import { useQuery } from '@tanstack/react-query';
import { myPulses, type PulseRow } from '@/lib/pulse/api';
import { Heart, Lock } from 'lucide-react';
import { format } from 'date-fns';

export function PulsesTable({ orgId }: { orgId: string }) {
  const { data, isLoading } = useQuery({
    queryKey: ['my_pulses', orgId],
    queryFn: async () => {
      const { data, error } = await myPulses(orgId, 90);
      if (error) throw error;
      return (data ?? []) as PulseRow[];
    },
  });

  if (isLoading) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (!data?.length) {
    return (
      <div className="text-center py-10 text-muted-foreground">
        <Heart className="h-8 w-8 mx-auto mb-2 opacity-50" />
        <p className="text-sm">No pulses yet.</p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-border rounded-md border border-border">
      {data.map((p) => (
        <li key={p.id} className="flex items-center gap-3 p-3">
          <span className="h-8 w-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-medium">
            {p.value}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm">{format(new Date(p.created_at), 'EEEE, MMM d')}</p>
            <p className="text-xs text-muted-foreground">{format(new Date(p.created_at), 'h:mm a')}</p>
          </div>
          <Lock className="h-3.5 w-3.5 text-muted-foreground/60" aria-label="Locked" />
        </li>
      ))}
    </ul>
  );
}
